interface LoadingStatusProps {
  message: string;
}

/**
 * Announces that a part of the page is loading, for readers that cannot see the skeletons standing
 * in for it — those are decorative and hidden from assistive technology.
 *
 * Render one per surface being awaited, so it is announced once, and pair
 * it with `aria-busy` on the container of a widget still missing elements it must own.
 */
const LoadingStatus = ({ message }: LoadingStatusProps) => {
  return (
    <p role="status" className="visuallyHidden">
      {message}
    </p>
  );
};

export default LoadingStatus;
